export type TipoComissaoPessoa = 'acompanhamento' | 'atividades';

export type PeriodoFiltroComissao = 'todos' | 'por-periodo' | 'codigo-reuniao' | 'proximos-15-dias' | 'proximos-30-dias';
export type StatusReuniaoComissao = 'agendada' | 'remarcada' | 'realizada' | 'cancelada' | 'excluida';
export type TipoFiltroComissao = 'todas' | 'comissao-interna' | 'camara-tecnica-interna' | 'comissao-camara-externa' | 'grupo-trabalho-interno';
export type ConvocacaoFiltroComissao = 'todas' | 'pendentes' | 'confirmacoes-pendentes';
export type AtaFiltroComissao = 'todas' | 'nao-marcadas' | 'importantes';
export type StatusAtaFiltroComissao = 'todos' | 'pendente' | 'realizada' | 'cancelada' | `id:${number}`;
export type SituacaoPresencaAta = 'presente' | 'virtual' | 'ausente' | 'justificado' | 'secretario' | 'coordenador';

export interface ParticipanteAta {
    idSolicitante: number;
    uf: string;
    nome: string;
    inPresenca?: string;
    inFuncao?: string;
    situacao: SituacaoPresencaAta;
}

export interface AtividadeAta {
    idTarefa: number;
    numero: string;
    descricao: string;
    resolvida: boolean;
    txObservacao?: string;
    dtInicio?: string;
    dtTermino?: string;
    idSituacaoTarefa?: number;
    idSolicitanteResponsavel?: number;
    sgUfSolicitanteResponsavel?: string;
    nmSolicitanteResponsavel?: string;
    idEstruturaOrganizacional?: number;
}

export interface ReuniaoSalvarPayload {
    dhInicioReuniao: string;
    dhFimReuniao: string;
    idLocalReuniao: number;
    idEstruturaOrganizacional: number;
    idTipoComissaoCt: number;
    idSolicitanteAssistente?: number | null;
    ufSolicitanteAssistente?: string | null;
    idSolicitanteCoordenador?: number | null;
    sgUfCoordenador?: string | null;
    inModalidade: string;
    inVisivelPortal: string;
}

export interface FiltrosComissoes {
    periodo: PeriodoFiltroComissao;
    codigoReuniao: string;
    dataInicial: string;
    dataFinal: string;
    status: 'todas' | StatusReuniaoComissao;
    tipoComissao: TipoFiltroComissao;
    comissaoNome: string;
    comissaoEstruturaId: number | null;
    membroConvidado: string;
    assistente: string;
    statusAta: StatusAtaFiltroComissao;
    local: string;
    convocacoes: ConvocacaoFiltroComissao;
    atas: AtaFiltroComissao;
}

export interface OpcaoFiltroComissao {
    rotulo: string;
    valor: string;
}

export interface ReuniaoComissao {
    codigo: string;
    tipoPessoa: TipoComissaoPessoa;
    status: StatusReuniaoComissao;
    idStatusReuniao?: number;
    descricaoStatus?: string;
    visivelPortal: boolean;
    modalidade: string;
    atividades: string;
    codigoComissao: string;
    idEstruturaOrganizacional?: number;
    nomeComissao: string;
    statusAta: string;
    idStatusAta?: number;
    descricaoStatusAta?: string;
    idProximoStatus?: number;
    idStatusAnterior?: number;
    descricaoStatusAtaProximo?: string;
    descricaoStatusAtaAnterior?: string;
    local: string;
    idLocalReuniao?: number;
    dataHoraCadastro: Date | null;
    dataInicio: Date | null;
    dataTermino: Date | null;
    convocacoes: number;
    confirmacoes: number;
    totalMembros?: number;
    atosConcessao: number;
    importante: string;
    dsImportante?: string;
    protocolo: string;
    assistente: string;
    idSolicitanteAssistente?: number;
    ufSolicitanteAssistente?: string;
    idSolicitanteCoordenador?: number;
    ufSolicitanteCoordenador?: string;
    nomeCoordenador?: string;
    membrosConvidadosPresentes: string[];
    tipoComissao: Exclude<TipoFiltroComissao, 'todas'>;
    idTipoComissaoCt?: number;
    possuiConvocacaoPendente: boolean;
    possuiConfirmacaoPendente: boolean;
    ataMarcada: boolean;
}

export const OPCOES_PERIODO_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todos', valor: 'todos' },
    { rotulo: 'Por período', valor: 'por-periodo' },
    { rotulo: 'Reuniões próximos 15 dias', valor: 'proximos-15-dias' },
    { rotulo: 'Reuniões próximos 30 dias', valor: 'proximos-30-dias' }
];

export const OPCOES_STATUS_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todas', valor: 'todas' },
    { rotulo: 'Agendada', valor: 'agendada' },
    { rotulo: 'Remarcada', valor: 'remarcada' },
    { rotulo: 'Realizada', valor: 'realizada' },
    { rotulo: 'Cancelada', valor: 'cancelada' },
    { rotulo: 'Excluída', valor: 'excluida' }
];

export const OPCOES_TIPO_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todas', valor: 'todas' },
    { rotulo: 'Comissão interna', valor: 'comissao-interna' },
    { rotulo: 'Câmara técnica interna', valor: 'camara-tecnica-interna' },
    { rotulo: 'Comissão, câmara técnica ou grupo de trabalho externo', valor: 'comissao-camara-externa' },
    { rotulo: 'Grupo de trabalho interno', valor: 'grupo-trabalho-interno' }
];

export const OPCOES_CONVOCACOES_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todas', valor: 'todas' },
    { rotulo: 'Reuniões com convocações pendentes', valor: 'pendentes' },
    { rotulo: 'Reuniões com confirmações pendentes', valor: 'confirmacoes-pendentes' }
];

export const OPCOES_ATAS_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todas', valor: 'todas' },
    { rotulo: 'Não marcadas', valor: 'nao-marcadas' },
    { rotulo: 'Importantes', valor: 'importantes' }
];

export const OPCOES_STATUS_ATA_COMISSOES: OpcaoFiltroComissao[] = [
    { rotulo: 'Todos', valor: 'todos' },
    { rotulo: 'Pendente', valor: 'pendente' },
    { rotulo: 'Realizada', valor: 'realizada' },
    { rotulo: 'Cancelada', valor: 'cancelada' }
];

export function criarFiltrosComissoesIniciais(): FiltrosComissoes {
    return {
        periodo: 'todos',
        codigoReuniao: '',
        dataInicial: '',
        dataFinal: '',
        status: 'todas',
        tipoComissao: 'todas',
        comissaoNome: '',
        comissaoEstruturaId: null,
        membroConvidado: '',
        assistente: 'todos',
        statusAta: 'todos',
        local: 'todos',
        convocacoes: 'todas',
        atas: 'todas'
    };
}
